import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import {catchError} from 'rxjs/operators';
import {Cookie} from 'ng2-cookies/ng2-cookies';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public tokenData = {access_token: ''};

  constructor(private http: HttpClient, private router: Router) { }

  public login(loginData) {
    const params = new URLSearchParams();
    params.append('username', loginData.username);
    params.append('password', loginData.password);
    params.append('grant_type', 'password');
    params.append('client_id', 'rexplorer');

    // const httpHeaders = new Headers({
    //   'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
    //   Authorization: 'Basic ' + btoa('fooClientIdPassword:secret')
    // });
    // const options = { headers: httpHeaders };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/x-www-form-urlencoded; charset=utf-8',
        Authorization: 'Basic ' + btoa('rexplorer:0UDo!lthASt#')
      })
    };
    console.log(params.toString());
    this.http.post('http://localhost:12318/oauth/token', params.toString(), httpOptions)
      // .pipe(catchError(err => console.error(err)))
      .subscribe(
        data => this.saveToken(data),
        err => alert('Invalid Credentials')
      );
  }

  private saveToken(tokenData) {
    console.log('TokenData', tokenData);
    localStorage.setItem('TOKEN_DATA', tokenData);
    const expireDate = new Date().getTime() + (1000 * tokenData.expires_in);
    Cookie.set('access_token', tokenData.access_token, expireDate);
    localStorage.setItem('TOKEN', tokenData.access_token);
    this.router.navigate(['/']);
  }

  public token() {
    return localStorage.getItem('TOKEN');
  }

  public checkAuthorization() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        Authorization: 'Bearer ' + this.token()
      })
    };
    this.http.get('http://localhost:12320/user/info', httpOptions)
      .subscribe(
        data => console.log('Check Auth:', data),
        err => {
          console.log('Check Auth:', err);
          this.router.navigate(['/login']);
        }
      );
    // if (!Cookie.get('access_token')) {
    //   this.router.navigate(['/login']);
    // }
  }
}
